// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__yn2hU","text":"SelectPayment_text__1NvAs","title":"SelectPayment_title__2up4J","btn":"SelectPayment_btn__2blcq"};